import { Link, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../auth/useAuth.js';

const moduleLinks = [
  ['Campaigns', 'campaigns'],
  ['Creators', 'creators'],
  ['Content', 'content'],
  ['Finance', 'finance'],
  ['Deliverables', 'deliverables'],
  ['Rights', 'rights'],
] as const;

export function MainNavigation() {
  const location = useLocation();
  const { tenantSlug } = useParams();
  const { user, isAuthenticated } = useAuth();
  const slug = tenantSlug ?? 'workspace';
  const tenantPath = (path: string) => `/app/${slug}/${path}`;
  const active = (path: string) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav className="main-navigation">
      <div className="nav-brand"><Link to={isAuthenticated ? `/app/${slug}` : '/'}>BumBum Platform</Link></div>
      <div className="nav-menu">
        {isAuthenticated && moduleLinks.map(([label, path]) => (
          <Link key={path} to={tenantPath(path)} className={active(tenantPath(path)) ? 'active' : ''}>{label}</Link>
        ))}
      </div>
      <div className="nav-user">
        {isAuthenticated && user ? (
          <div className="user-info">
            <span>{user.displayName || user.email}</span>
            <Link to={tenantPath('profile')}>Profile</Link>
            <Link to="/logout">Logout</Link>
          </div>
        ) : (
          <div className="auth-links"><Link to="/login">Login</Link><Link to="/signup">Sign Up</Link></div>
        )}
      </div>
    </nav>
  );
}